import React from "react";
import ReactDom from "react-dom";

import { extendObservable, observable, computed, action, reaction, autorun, when } from 'mobx';
import { observer, inject } from 'mobx-react';

import autoclass from 'autoclass-decorator';
import BaseComponent from 'base-component';
import BaseViewStore from 'base-viewstore';

import {Mixin, mix} from 'mixwith';

import {ViewControllerMixin} from 'layout-component';

import DataModel from 'simgate-datamodel';

import ProjectDomainStore from 'project-domain-store';
import SimDomainStore from 'sim-domain-store';

@observer
export class MenuBar extends BaseComponent {
  render(){
    const {viewMap, clickItem, currentView, currentViewId, currentRound, isEvent} = this.props;
    let specificItems = [];
    let genericItems = [];
    const positions = [
      "Strategy",
      "Lease Management",
      "Exploration",
      "Development",
      "Production",
      "Transportation",
      "Refining",
      "Product Marketing",
    ];
    let home = null;
    let resources = null;
    let financials = null;
    Object.keys( viewMap ).reduce( (acc,k) => {
      const v = viewMap[k]
      let element = null;
      if(typeof v === "function"){
        element = { id: k, Component: v };
      }else if(v.show || (v.menu && v.menu.show)){
        element = v;
      }else if(v.onClick || v.clickItem){
        element =  Object.assign({}, v, {id: k}, {clickItem: v.onClick || v.clickItem });
      }

      if(!element || element.menu.displayName.indexOf("Event") == 0) {
        return;
      }

      element.iconClass = element.icon || (element.contentModel && element.contentModel.icon) || "";
      element.menu = Object.assign( {clickItem: clickItem}, element, element.menu );
      element.itemStatus = (currentViewId && element.menu.id === currentViewId) || (currentView && currentView.id === element.menu.id) ? "active" : "inactive";
      element.itemStatus += (element.contentModel && element.contentModel.activity && (element.contentModel.activity.isSubmitted || element.contentModel.activity.isCompleted)) ? " complete" : "";
      element.itemStatus += isEvent ? " disabled" : "";
      

      if(positions.indexOf(element.menu.displayName) >= 0) {
        specificItems[positions.indexOf(element.menu.displayName)] = element;
      }
      else if(element.menu.displayName == "Home") {
        home = element;
      }
      else if(element.menu.displayName == "Resources") {
        resources = element;
      }
      else if(element.menu.displayName == "Financials") {
        financials = element;
      }
      else {
        genericItems.push(element);
      }
      return [];
    }, []);
    
    function getItem(css, item) {
      return (<div className={"item " + css + " " + item.itemStatus + " " + item.menu.id} onClick={e => !!item.menu.clickItem && item.menu.clickItem(item, viewMap) } disabled={item.menu.hasOwnProperty('enabled') ? !item.menu.enabled : false}>
          <div className="icon"></div>
          <div className="label">{item.menu.displayName || item.menu.id}</div>
      </div>);
    }

    return (
        <div className="menu">
            {home && 
                <div className={"item home " + (isEvent ? " disabled " : " ") + home.menu.id} onClick={e => !!home.menu.clickItem && home.menu.clickItem(home, viewMap) } >
                    <div className="icon"></div>
                    <div className="label">Home</div>
                </div>
            }
            {resources && 
                <div className={"item resources " + (isEvent ? " disabled " : " ") + " " + resources.menu.id} style={{paddingTop: 0, paddingBottom: '5px'}} onClick={e => !!resources.menu.clickItem && resources.menu.clickItem(resources, viewMap) } >
                    <div className="icon"></div>
                    <div className="label">Resources</div>
                </div>
            }
            {financials && 
                <div className={"item financials " + (isEvent ? " disabled " : " ") + " " + financials.menu.id} style={{paddingTop: 0}} onClick={e => !!financials.menu.clickItem && financials.menu.clickItem(financials, viewMap) } >
                    <div className="icon fa fa-book"></div>
                    <div className="label">Financials</div>
                </div>
            }

            <div className="item message round">{!!currentRound && currentRound.displayName || currentRound.id}</div>
            
            <div className="sub-menu">
              {genericItems.map( (view, index) => {
                  return (
                      <div key={"" + view.menu.id + index} className={"item " + view.iconClass + " " + view.itemStatus + " " + view.menu.id} onClick={e => !!view.menu.clickItem && view.menu.clickItem(view, viewMap) } disabled={view.menu.hasOwnProperty('enabled') ? !view.menu.enabled : false}>
                          <div className="icon"></div>
                          <div className="label">{view.menu.displayName || view.menu.id}</div>
                      </div>
                  )
              })}
            </div>
            {specificItems[0] && (
                <div className="sub-menu">
                    <div className="title">Strategy</div>
                    {getItem("capital", specificItems[0])}
                </div>
            )}

            {(specificItems[1] || specificItems[2] || specificItems[3] || specificItems[4]) && (
              <div className="sub-menu">
                  <div className="title">Upstream</div>
                  {specificItems[1] && getItem("lease", specificItems[1])}
                  {specificItems[2] && getItem("exploration", specificItems[2])}
                  {specificItems[3] && getItem("development", specificItems[3])}
                  {specificItems[4] && getItem("production", specificItems[4])}
              </div>
            )}
            
            {specificItems[5] && (
              <div className="sub-menu">
                  <div className="title">Midstream</div>
                  {getItem("transportation", specificItems[5])}
              </div>
            )}
            
            {(specificItems[7] || specificItems[7]) && (
              <div className="sub-menu">
                  <div className="title">Downstream</div>
                  {specificItems[1] && getItem("refining", specificItems[6])}
                  {specificItems[2] && getItem("marketing", specificItems[7])}
              </div>
            )}
        </div>
    )
  }
}


export class DefaultShellViewStore extends mix(BaseViewStore).with(ViewControllerMixin){
  
  @observable isInitilized = false;
  @observable needsStrategy = true;

  constructor(){
    super(...arguments);

    // <Shell 
    //   contentModel={simulation.shell} 
    //   simulation={simulation} 
    //   dataModel={dataModel} 
    //   projectDomainStore={projectDomainStore}
    //   parentPathId={parentPathId}
    //   application={application}
    // />

    const {
      contentModel: shell,
      simulation,
      dataModel: {
        domainStore: simDomainStore
      },
      projectDomainStore,
      parentPathId,
      application
    } = this.props;

    window.application.shell = this;
  }

  @action.bound completeState(){
    const {
      dataModel: {
        domainStore: simDomainStore
      }
    } = this.props;

    simDomainStore.completeTask();
  }

  @computed get currentRound(){
    const {
      simulation,
      dataModel: {
        domainStore: simDomainStore
      }
    } = this.props;

    const round = simulation.rounds[ simDomainStore.currentRoundNo ? simDomainStore.currentRoundNo-1 : 0 ];
    return round;
  }
  @computed get currentTeamState(){
    const {
      dataModel: {
        domainStore: simDomainStore
      }
    } = this.props;
    return this.currentRound.teamStates.find( ts => ts.id === simDomainStore.teamStateName )
  }
  @computed get currentTeamName() {
    const projectDomainStore = this.props.projectDomainStore;
    
    return (projectDomainStore.context && projectDomainStore.context.team && projectDomainStore.context.team.name) || "-";
  }
  @computed get currentSessionName() {
    const projectDomainStore = this.props.projectDomainStore;
    
    return (projectDomainStore.context && projectDomainStore.context.sessionName) || "-";
  }
  @computed get eventList(){
    const {
      dataModel,
      dataModel: {
        domainStore: simDomainStore
      }
    } = this.props;

    const tasks = this.currentTeamState.tasks;
    return tasks && tasks.reduce( (acc, task) => {
      if(task.displayTitle.indexOf("Event") < 0) {
          return acc;
      }
      acc[task.displayTitle] = {
        id: task.id,
        contentModel: task,
        menu: {
          get show(){ return true }, // can be computed based on activity
          get enabled(){ return true }, // can be computed based on activity
          displayName: task.displayTitle || task.id
        },
        dataModel: dataModel,
        viewMode: "simulation"
      };
      return acc;
    }, {})
  }
  @computed get viewMap(){
    const {
      dataModel,
      dataModel: {
        domainStore: simDomainStore
      }
    } = this.props;

    if(!simDomainStore.pathId || !simDomainStore.teamStateName) return {
      "loading": {
        id: "loading",
        Component: () => <div>Loading...</div>
      }
    }

    const tasks = this.currentTeamState.tasks;
    return tasks && tasks.reduce( (acc, task) => {
      acc[task.id] = {
        id: task.id,
        contentModel: task,
        menu: {
          get show(){ return true }, // can be computed based on activity
          get enabled(){ return true }, // can be computed based on activity
          displayName: task.displayTitle || task.id
        },
        dataModel: dataModel,
        viewMode: "simulation"
      };
      return acc;
    }, {})
  }
  @action.bound logout() {
      const {
          contentModel, 
          dataModel: {
            domainStore: projectDomainStore
          },
      } = this.props;
      const modalViewStore = window.application.modalViewStore;

      //just in case we're already signed in :-)
      if(!(process && process.env && process.env.mockMode)) projectDomainStore.refreshContext();

      const dirtyEntities = contentModel.$parent.entities.values().filter( ent => ent.isDirty );
      modalViewStore.setModal({
          title: "Are you sure you want to log out?",
          message: "Any unsaved changes may be lost.",
          confirmLabel: 'Logout',
          confirmBtnClass: 'green check-a',
          cancelLabel: 'Cancel',
          cancelBtnClass: 'red times-b',
          onConfirmFunc: () => { projectDomainStore.simgate.signOut().then(() => window.location.reload()).catch(() => window.location.reload()); }
      })
  }

  @computed get roundComplete() {
    let complete = 0;
    let total = 0;
    const viewMap = this.viewMap;
    
    if(viewMap.loading) {
      return 0;
    }

    for(let i in viewMap) {
        const view = viewMap[i];
        if(view.menu.displayName == "Resources" || view.menu.displayName == "Home" || view.menu.displayName == "Financials" || view.menu.displayName == "Event 1.2") {
          continue;
        }
        complete += view.contentModel.activity.isSubmitted ? 1 : 0;
        total += 1;
    }
    if(total == 0 || complete == 0) {
        return 0;
    }
    if(complete >= total) {
        return 1;
    }

    return complete / total;
  }

  @computed get isEvent() {
      const current = this.currentView;
      return current && current.menu && current.menu.displayName && current.menu.displayName.indexOf("Event") == 0;
  }

  @action.bound showEvent(event) {
    this.selectView(event);
  }

  advanceInterval = null;
  @action.bound checkForAdvanced() {

      if(this.advanceInterval || this.roundComplete < 1) {
          return;
      }

      const {
        simulation,
        dataModel: {
          domainStore: simDomainStore
        }
      } = this.props;
  
      const roundNo = simDomainStore.currentRoundNo ? simDomainStore.currentRoundNo - 1 : 0;

      const self = this;
      this.advanceInterval = setInterval(function() {
          simDomainStore.refreshContext(() => {
              const newRoundNo = simDomainStore.currentRoundNo ? simDomainStore.currentRoundNo - 1 : 0;
              if(newRoundNo != roundNo) {
                  clearInterval(self.advanceInterval);
                  self.advanceInterval = null;
                  self.isInitilized = false;
                  return;
              }
          });

      }, 15 * 1000);
  }

  @action.bound preSelectView(menu) {
      if(this._currentView == menu.id) { return; }
      this.selectView(menu);
  }

  @action.bound updateState() {
    const {
        contentModel, 
        dataModel: {
            domainStore
        },
    } = this.props;
    
        
    this.isInitilized = true;
    const viewMap = this.viewMap;
    const eventList = this.eventList;
    const selectView = this.selectView;
    const roundComplete = this.roundComplete;
    let self = this;

    let first = null;
    let home = null;
    let resources = null;
    let financials = null;
    let inputs = [];
    
    for(let i in viewMap) {
        const view = viewMap[i];
        inputs.push(view.contentModel.activity.id + "_isSubmitted");
    }
    
    this.isLoading = true;
    
    if(!window.application.dataModel.domainStore.context.team || !window.application.dataModel.domainStore.context.team.pathId || inputs.length == 0) {
        return;
    }

    const taskArgs = [
        domainStore.simgate.selectData, {
            select: inputs,
            path: window.application.dataModel.domainStore.context.team.pathId
        },{
            //wrap in action for mobx transaction purposes (only refresh views after complete)
            onSuccess: action("loadData-callback", res => {
                const data = res.selected && res.selected.data || {};

                let any = false;
                for(let i in viewMap) {
                    (function(view) {
                        const variable = view.contentModel.activity.id + "_isSubmitted";
                        view.contentModel.activity.isSubmitted = data && data[variable] !== undefined && !!data[variable];

                        if(!home) {
                            home = view;
                        }
                        else if(!resources) {
                            resources = view;
                        }
                        else if(!financials) {
                          financials = view;
                        }
                        any = any || view.contentModel.activity.isSubmitted;
                        if((!first || first == home || first == resources || first == financials) && !view.contentModel.activity.isSubmitted) {
                            first = view;
                        }

                        if(view.contentModel.displayTitle == "Strategy") {
                          self.needsStrategy = !view.contentModel.activity.isSubmitted;
                        }

                        if(view.contentModel.displayTitle == "Development" && window.application.dataModel.domainStore.context.team.num5 == 1) {
                            const event = eventList["Event 1.1"];
                            if(!event) { return; }
                            if(view.contentModel.activity.isSubmitted && !event.isSubmitted) {
                                first = event;
                                self.showEvent(event);
                                when(
                                    () => event.contentModel.activity.isSubmitted,
                                () => {
                                    let selected = false;
                                    for(let j in viewMap) {
                                        if(viewMap[j].contentModel.displayTitle == "Production") {
                                            selectView(viewMap[j], viewMap);
                                            selected = true;
                                        }
                                    }
                                    if(!selected) {
                                        selectView(view);
                                    }
                                });
                            }
                            else if(!view.contentModel.activity.isSubmitted) {
                                when(
                                    () => view.contentModel.activity.isSubmitted,
                                    () => {
                                        self.showEvent(event);
                                        when(
                                            () => event.contentModel.activity.isSubmitted,
                                        () => {
                                            let selected = false;
                                            for(let j in viewMap) {
                                                if(viewMap[j].contentModel.displayTitle == "Production") {
                                                    selectView(viewMap[j], viewMap);
                                                    selected = true;
                                                }
                                            }
                                            if(!selected) {
                                                selectView(view);
                                            }
                                        });
                                    }
                                );
                            }
                        }
                        else if(view.contentModel.displayTitle == "Refining" && window.application.dataModel.domainStore.context.team.num5 == 1) {
                            const event = eventList["Event 1.2"];
                            if(!event) { return; }
                            if(!view.contentModel.activity.isSubmitted) {
                                when(
                                    () => view.contentModel.activity.isSubmitted,
                                    () => {
                                        if(view.contentModel.activity.HSEIndex === undefined || view.contentModel.activity.HSEIndex > 112) {
                                            return;
                                        }
                                        self.showEvent(event);
                                        when(
                                            () => event.contentModel.activity.isSubmitted,
                                        () => {
                                            let selected = false;
                                            for(let j in viewMap) {
                                                if(viewMap[j].contentModel.displayTitle == "Product Marketing") {
                                                    selectView(viewMap[j], viewMap);
                                                    selected = true;
                                                }
                                            }
                                            if(!selected) {
                                                selectView(view);
                                            }
                                        });
                                    }
                                );
                            }
                        }
                        else if(view.contentModel.displayTitle == "Production" && window.application.dataModel.domainStore.context.team.num5 == 2) {
                            const event = eventList["Event 2.1"];
                            if(!event) { return; }
                            if(view.contentModel.activity.isSubmitted && !event.isSubmitted) {
                                first = event;
                                self.showEvent(event);
                                when(
                                    () => event.contentModel.activity.isSubmitted,
                                () => {
                                    let selected = false;
                                    for(let j in viewMap) {
                                        if(viewMap[j].contentModel.displayTitle == "Transportation") {
                                            selectView(viewMap[j], viewMap);
                                            selected = true;
                                        }
                                    }
                                    if(!selected) {
                                        selectView(view);
                                    }
                                });
                            }
                            else if(!view.contentModel.activity.isSubmitted) {
                                when(
                                    () => view.contentModel.activity.isSubmitted,
                                    () => {
                                        self.showEvent(event);
                                        when(
                                            () => event.contentModel.activity.isSubmitted,
                                        () => {
                                            let selected = false;
                                            for(let j in viewMap) {
                                                if(viewMap[j].contentModel.displayTitle == "Transportation") {
                                                    selectView(viewMap[j], viewMap);
                                                    selected = true;
                                                }
                                            }
                                            if(!selected) {
                                                selectView(view);
                                            }
                                        });
                                    }
                                );
                            }
                        }
                        else if(view.contentModel.displayTitle == "Transportation" && window.application.dataModel.domainStore.context.team.num5 == 2) {
                            const event = eventList["Event 2.2"];
                            if(!event) { return; }
                            if(view.contentModel.activity.isSubmitted && !event.isSubmitted) {
                                first = event;
                                self.showEvent(event);
                                when(
                                    () => event.contentModel.activity.isSubmitted,
                                () => {
                                    let selected = false;
                                    for(let j in viewMap) {
                                        if(viewMap[j].contentModel.displayTitle == "Refining") {
                                            selectView(viewMap[j], viewMap);
                                            selected = true;
                                        }
                                    }
                                    if(!selected) {
                                        selectView(view);
                                    }
                                });
                            }
                            else if(!view.contentModel.activity.isSubmitted) {
                                when(
                                    () => view.contentModel.activity.isSubmitted,
                                    () => {
                                        self.showEvent(event);
                                        when(
                                            () => event.contentModel.activity.isSubmitted,
                                        () => {
                                            let selected = false;
                                            for(let j in viewMap) {
                                                if(viewMap[j].contentModel.displayTitle == "Refining") {
                                                    selectView(viewMap[j], viewMap);
                                                    selected = true;
                                                }
                                            }
                                            if(!selected) {
                                                selectView(view);
                                            }
                                        });
                                    }
                                );
                            }
                        }
                        else if(view.contentModel.displayTitle == "Home" && window.application.dataModel.domainStore.context.team.num5 == 3) {
                            const event = eventList["Event 3.1"];
                            if(!event) { return; }
                            if(view.contentModel.activity.isSubmitted && !event.isSubmitted) {
                                first = event;
                                self.showEvent(event);
                                when(
                                    () => event.contentModel.activity.isSubmitted,
                                () => {
                                    let selected = false;
                                    for(let j in viewMap) {
                                        if(viewMap[j].contentModel.displayTitle == "Strategy") {
                                            selectView(viewMap[j], viewMap);
                                            selected = true;
                                        }
                                    }
                                    if(!selected) {
                                        selectView(view);
                                    }
                                });
                            }
                            else if(!view.contentModel.activity.isSubmitted) {
                                when(
                                    () => view.contentModel.activity.isSubmitted,
                                    () => {
                                        self.showEvent(event);
                                        when(
                                            () => event.contentModel.activity.isSubmitted,
                                        () => {
                                            let selected = false;
                                            for(let j in viewMap) {
                                                if(viewMap[j].contentModel.displayTitle == "Strategy") {
                                                    selectView(viewMap[j], viewMap);
                                                    selected = true;
                                                }
                                            }
                                            if(!selected) {
                                                selectView(view);
                                            }
                                        });
                                    }
                                );
                            }
                        }
                        else if(view.contentModel.displayTitle == "Refining" && window.application.dataModel.domainStore.context.team.num5 == 3) {
                            const event = eventList["Event 3.2"];
                            if(!event) { return; }
                            if(view.contentModel.activity.isSubmitted && !event.isSubmitted) {
                                first = event;
                                self.showEvent(event);
                                when(
                                    () => event.contentModel.activity.isSubmitted,
                                () => {
                                    let selected = false;
                                    for(let j in viewMap) {
                                        if(viewMap[j].contentModel.displayTitle == "Product Marketing") {
                                            selectView(viewMap[j], viewMap);
                                            selected = true;
                                        }
                                    }
                                    if(!selected) {
                                        selectView(view);
                                    }
                                });
                            }
                            else if(!view.contentModel.activity.isSubmitted) {
                                when(
                                    () => view.contentModel.activity.isSubmitted,
                                    () => {
                                        self.showEvent(event);
                                        when(
                                            () => event.contentModel.activity.isSubmitted,
                                        () => {
                                            let selected = false;
                                            for(let j in viewMap) {
                                                if(viewMap[j].contentModel.displayTitle == "Product Marketing") {
                                                    selectView(viewMap[j], viewMap);
                                                    selected = true;
                                                }
                                            }
                                            if(!selected) {
                                                selectView(view);
                                            }
                                        });
                                    }
                                );
                            }
                        }
                    })(viewMap[i]);
                }
                
                if(!any && home) {
                    selectView(home, viewMap);
                }
                else if(first) {
                    selectView(first, viewMap);
                }

                self.isLoading = false;
            }),
            onFailure: action("loadData-error", err => {
                debugger;
                alert("There was a problem loading your data - " + err);
            }),
        }
    ]

    if(domainStore.simgate.runTask) {
        domainStore.simgate.runTask(...taskArgs);
    } else if(domainStore.simgate.AsyncTask) {
        const asyncTask = new domainStore.simgate.AsyncTask();
        asyncTask.runTask(...taskArgs);             
    } else {
        domainStore.simgate.selectData(taskArgs[1]).then( taskArgs[2].onSuccess ).catch( taskArgs[2].onFailure );
    }
  }
}

@observer
//@autoclass
export class DefaultShellComponent extends BaseComponent{
  static ViewStore = DefaultShellViewStore
  render(){
    const {
      contentModel: shell,
      simulation,
      dataModel,
      projectDomainStore,
      parentPathId,
      application
    } = this.props;

    const {
      isInitilized,
      viewMap,
      preSelectView,
      clearView,
      SelectedView,
      currentRound,
      currentTeamState,
      currentTeamName,
      currentSessionName,
      completeState,
      logout,
      updateState,
      roundComplete,
      checkForAdvanced,
      isEvent,
      needsStrategy,
    } = this.viewStore

    if(!SelectedView && !viewMap["loading"] && !isInitilized) {
        updateState();
    }

    if(roundComplete == 1) {
        checkForAdvanced();
    }
    
    return <div className="app-shell">
    <div className="content">
        <div className={"side-bar" + (isEvent ? " disabled" : "")}>
            <div className="logo-bar">
                <div className="logo"></div>
            </div>
            <div className="tagline">Oil &amp; Gas</div>
            <MenuBar viewMap={viewMap} clickItem={ preSelectView } currentRound={currentRound} isEvent={isEvent} />
          </div>
          <div className="activity-area">
            {!SelectedView 
              ? <div dangerouslySetInnerHTML={{__html: shell.body }} ></div>
              : <SelectedView needsStrategy={needsStrategy}/>}
          </div>
      </div>
      <div className="footer">
          <div className="actions">
              <div className="action" onClick={logout}>Logout</div>
          </div>
          <div className="session-details">
              <div className="detail">Session: {currentSessionName}</div>
              <div className="detail">Team: {currentTeamName}</div>
              <div className="detail">Name: {projectDomainStore.context.user.loginName}</div>
              <div className="detail">{currentRound.displayName || currentRound.id}</div>
          </div>
          {roundComplete == 1 ?
            <div className="progress-bar">
                <div className="label" style={{width: "210px", fontSize: "18px"}}><i className="fa fa-spin fa-spinner fa-fw" style={{marginRight:"10px"}}></i>Waiting for facilitator</div>
            </div>
            :
            <div className="progress-bar">
                <div className="label">Round Progress:</div>
                <div className="bar">
                    <div className="fill" style={{width: (roundComplete * 100) + "%"}}></div>
                </div>
            </div>
          }

      </div>
    </div>
  }
}

export const Component = DefaultShellComponent;
export default Component;


// WEBPACK FOOTER //
// ./app_modules/default-simulation-shell/component.js